export const DataPackageName = {
    Unspecified: 'unspecified',
    IoBasedActivation: 'ioBasedActivation',
    PlatformSubscription: 'platformSubscription',
    DataSubscription: 'dataSubscription',
};
export const DataPackageFancyName = {
    unspecified: 'Unspecified',
    ioBasedActivation: 'IO Based Activation',
    platformSubscription: 'Platform Subscription',
    dataSubscription: 'Data Subscription',
};
export const DataPackageId = {
    Unspecified: 0,
    IoBasedActivation: 1,
    PlatformSubscription: 2,
    DataSubscription: 3,
};
//# sourceMappingURL=DataPackage.js.map